import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantMap } from "@/shared/utils/interfaces";
import { getRestaurantMapsQueryOptions } from "@/shared/utils/queryOptions";
import { useQuery } from "@tanstack/react-query";

const useRestaurantMaps = () => {
  const branch = useBranchId();
  const { queryKey, queryFn } = getRestaurantMapsQueryOptions(branch);

  return useQuery<RestaurantMap[]>({
    queryKey: queryKey,
    queryFn: queryFn,
  });
};

export default useRestaurantMaps;
